export class CalculatorData {
  totalBenefit: number;
  amountToPay: number;
  annualPremium: number;
  paymentFrequency: string;
  effectiveDate: string;
  premiumOrSumAssured: number;
  investmentAmount: number;
  targetType: string;
  term: number;

  // constructor() {
  //   this.totalBenefit = 0;
  //   this.amountToPay = 0;
  //   this.annualPremium = 0;
  //   this.paymentFrequency = '';
  //   this.effectiveDate = '';
  //   this.premiumOrSumAssured = 0;
  //   this.investmentAmount = 0;
  //   this.targetType = '';
  //   this.term = 0;
  // }
}

